import clsx from 'clsx';
import { useTranslations } from 'next-intl';
import { SortBy } from 'react-instantsearch';

import Text from '@commons/components/Text';
import Flex from '@commons/containers/Flex';
import { ALGOLIA_INDEX } from '@commons/utils/constants';

import styles from './SortBy.module.scss';

// Type definition for the SearchSortBy component properties.

type Props = {
  className?: string;
  rootClassName?: string;
  selectClassName?: string;
};

/**
 * SearchSortBy component.
 *
 * Uses replica indexes to sort search results.
 *
 * @see https://www.algolia.com/doc/api-reference/widgets/sort-by/react/
 */

const SearchSortBy = ({ className, rootClassName, selectClassName }: Props) => {
  const t = useTranslations('search.sortBy');

  return (
    <Flex gap="xxs" align="center" className={className}>
      <Text
        as="span"
        level="body-xs"
        transform="uppercase"
        marginBottom="none"
        className={styles.label}
      >
        {t('label')}
      </Text>
      <SortBy
        items={[
          { label: t('latest'), value: `${ALGOLIA_INDEX}_date_desc` },
          { label: t('relevance'), value: ALGOLIA_INDEX },
        ]}
        classNames={{
          root: clsx(styles.root, rootClassName),
          select: clsx(styles.select, selectClassName),
        }}
      />
    </Flex>
  );
};

export default SearchSortBy;
